module.exports = __webpack_public_path__ + "static/media/35-10.1d35831a.mp3";